'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util'),
    validator = require('../validator');

var newLine = '\n';
var storeTemplate = function (store, selectedStoreId, selectedStoreText) {
    return [
        '<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">',
        '    <p class="store-name">' + store.displayName + '</p>',
        '    <p class="store-address">',
        '        ' + store.address1 + '<br/>',
        '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
        '    </p>',
        '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>',
        '    <button class="select-store-button button-fancy-large btn-outline-dark" data-store-id="' + store.storeId + '"' + '>',
        '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE),
        '    </button>',
        '</li>'
    ].join(newLine);
};

var storeListTemplate = function (stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        window.updateZip = false;

        return [
            '<div class="store-list-container">',
            '<ul class="store-list">',
            _.map(stores, function (store) {
                return storeTemplate(store, selectedStoreId, selectedStoreText);
            }).join(newLine),
            '</ul>',
            '</div>',
            '<div class="store-list-pagination">',
            '</div>'
        ].join(newLine);
    } else {
        return '<div class="no-results">' + String.format(Resources.NOSTOREFOUND, SitePreferences.STORE_LOOKUP_DISTANCE, SitePreferences.STORE_LOOKUP_UNIT, User.zip) + '</div>';
    }
};

var zipPromptTemplate = function () {
    return [
        `
        <form id="zip-prompt-form"><div id="preferred-store-panel" class="c-form-row form-row">
            <div class="c-form-row__form-field-container">
                <input type="text" id="user-zip" name="zipCode" class="c-form-row__input input-text postal ca-postal"
                    placeholder="${Resources.ENTER_ZIP}"
                    required
                    data-msg-required="${Resources.ENTER_ZIP_FORMAT}"
                />
            </div>
        </div></form>
        `
    ].join(newLine);
};

var storeinventory = {
    zipPrompt: function (callback) {
        var self = this;
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                dialogClass: 'find-in-store-modal',
                title: Resources.STORE_NEAR_YOU,
                width: 500,
                buttons: [{
                    text: Resources.SEARCH,
                    class: 'button-fancy-large',
                    click: function () {
                        if ($('#zip-prompt-form').valid()) {
                            var zipCode = $('#user-zip').val();
                            self.setUserZip(zipCode);
                            if (callback) {
                                callback(zipCode);
                            }
                        }
                    }
                }],
                open: function () {
                    //Need to merge buttonpane into container for layout to display and scroll properly
                    var buttonPane = $('.ui-dialog-buttonpane');
                    buttonPane.detach();
                    $('#dialog-container').append(buttonPane);

                    $('#user-zip').on('keypress', function (e) {
                        if (e.which === 13) {
                            // trigger the search button
                            $('.ui-dialog-buttonset .ui-button').trigger('click');
                        }
                    });

                    validator.init();
                }
            }
        });
    },
    getStoresInventory: function (pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function (options) {
        var stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText;
        dialog.open({
            html: storeListTemplate(stores, selectedStoreId, selectedStoreText),
            options: {
                dialogClass: 'find-in-store-modal',
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                buttons: [{
                    text: Resources.CHANGE_LOCATION,
                    class: 'button-fancy-large',
                    click: function () {
                        //Rather than set User.zip to null, just toggle a setting saying the user wants to update it
                        //That way, if the user doesn't actually enter anything new, we can default to the last zip code they provided
                        window.updateZip = true;
                        // trigger the event to start the process all over again
                        $('.set-preferred-store').trigger('click');
                    }.bind(this)
                }, {
                    text: Resources.CONTINUE,
                    class: 'button-fancy-large',
                    click: function () {
                        if (options.continueCallback) {
                            options.continueCallback(stores);
                        }
                        dialog.close();
                    }
                }],
                open: function () {
                    //Need to merge buttonpane into container for layout to display and scroll properly
                    var buttonPane = $('.ui-dialog-buttonpane');
                    buttonPane.detach();
                    $('#dialog-container').append(buttonPane);

                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        var storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) { return; }
                        $('.store-list .store-tile.selected').removeClass('selected')
                            .find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText)
                            .closest('.store-tile').addClass('selected');
                        selectedStoreId = storeId;
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                    });
                }
            }
        });
    },
    setUserZip: function (zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function () {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;
